// removed by extract-text-webpack-plugin
module.exports = {"page-front-login-sp":"page-front-login-sp","logo-img":"logo-img","logo-user":"logo-user","logo-username":"logo-username"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/WelcomeContainer/Index.scss
// module id = 1377
// module chunks = 0